import React from 'react';
import ReactDOM from 'react-dom';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, message, title = 'Confirm Delete', icon = '⚠️' }) => {
  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content large" style={{ maxWidth: 400, textAlign: 'center', padding: 32 }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>{icon}</div>
        <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 8, color: '#d32f2f' }}>{title}</div>
        <div style={{ fontSize: 17, marginBottom: 24 }}>{message}</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
          <button
            onClick={onClose}
            className="btn btn-secondary"
            style={{ minWidth: 100, fontSize: 16 }}
          >
            Cancel
          </button>
          <button
            onClick={() => { onConfirm(); onClose(); }}
            className="btn btn-danger"
            style={{ minWidth: 100, fontSize: 16 }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmModal; 